import SliderWithInput from '../../SliderWithInput';
import SwitchWithInput from '../../SwitchWithInput';

interface ChartSpecificControlsProps {
  chartType: string;
  propKey: string;
  from?: string;
  areaOpacity: number;
  colorBy: string;
  setAreaColorOptions: (option: string, value: any) => void;
  updateBoxPlotStyleOptions: (option: string, value: any) => void;
  color?: string;
}

const ChartSpecificControls = ({
  chartType,
  propKey,
  from,
  areaOpacity,
  colorBy,
  setAreaColorOptions,
  updateBoxPlotStyleOptions,
  color,
}: ChartSpecificControlsProps) => {
  if ((chartType === 'area' || chartType === 'stackedArea') && from !== 'dashboard') {
    return (
      <>
        <div className="optionDescription" style={{ marginTop: '10px', color: color }}>
          Opacity
        </div>
        <div style={{ marginLeft: '4px', marginRight: '-4px' }}>
          <SliderWithInput
            pointNumbers={true}
            sliderValue={areaOpacity}
            sliderMinMax={{ min: 0, max: 1, step: 0.1 }}
            changeValue={(value: number) => setAreaColorOptions('areaOpacity', value)}
          />
        </div>
      </>
    );
  }

  if (chartType === 'boxPlot') {
    return (
      <>
        <div
          className="optionDescription"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '5px',
            paddingLeft: '0.25rem',
            color: color,
          }}
        >
          <label htmlFor="enableDisable" className="enableDisableLabel" style={{}}>
            Color By Category
          </label>

          <div
            style={{
              width: '50px',
              height: '24px',
              display: 'flex',
              transform: 'translateX(63px)',
              marginBottom: '9px',
            }}
          >
            <SwitchWithInput
              isChecked={colorBy === 'data'}
              onSwitch={() =>
                updateBoxPlotStyleOptions('colorBy', colorBy === 'series' ? 'data' : 'series')
              }
            />
          </div>
        </div>
      </>
    );
  }

  return null;
};

export default ChartSpecificControls;
